import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';
import { UserPositionDto } from '../entities/user-position.dto';

export interface UserPositionExitCleanupTask {
    /** Stable id, useful for logging and ordering. */
    readonly id: string;
    /** True if this task applies to the position being exited. */
    appliesTo(position: UserPositionDto): boolean;
    /** Side-effects to run before the position is marked Exited. */
    cleanup$(position: UserPositionDto): Observable<unknown>;
}

export const USER_POSITION_EXIT_CLEANUP_TASKS = new InjectionToken<
    UserPositionExitCleanupTask[]
>('USER_POSITION_EXIT_CLEANUP_TASKS');
